export default {
  name: 'Footer',
  components: {},
  props: {},
  data: () => ({

  }),
  computed: {},
  methods: {},
};
